import { render, staticRenderFns } from "./HorizontalQuestionLayout.vue?vue&type=template&id=402612ac&scoped=true&"
import script from "./HorizontalQuestionLayout.vue?vue&type=script&lang=js&"
export * from "./HorizontalQuestionLayout.vue?vue&type=script&lang=js&"
import style0 from "./HorizontalQuestionLayout.vue?vue&type=style&index=0&id=402612ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402612ac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VCol,VContainer,VRow})
